import { requestData } from "./utils";

interface GetAlertsData {
  enterpriseId?: string;
  entityId?: string;
  userId?: string;
  page: number;
  pageSize: number;
}
export default class AlertsModule {
  getAlerts(data: GetAlertsData, signal: AbortSignal) {
    const { enterpriseId, entityId, userId, page, pageSize } = data;

    return requestData(
      "GET",
      `/alerts?enterprise_id=${enterpriseId}&user_id=${userId}&page=${page}&page_size=${pageSize}&entity_id=${entityId}`,
      null,
      undefined,
      signal
    );
  }
}
